<template>
  <div class="page-wrap">
    <!-- ========== 顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <div v-if="isMobile" class="hamburger-btn" @click="mobileMenuDrawer = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div class="header-right">
        <div class="header-icon">
          <i class="el-icon-bell"></i>
        </div>
        <div v-if="visible_loginMenu">
          <el-dropdown trigger="click" @command="handleAccountCommand">
            <div class="header-icon user-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info">资产</el-dropdown-item>
              <el-dropdown-item command="order">我的订单</el-dropdown-item>
              <el-dropdown-item command="logout" divided style="color: #f53f3f">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else>
          <div class="header-icon user-icon" @click="login">
            <i class="el-icon-user"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- PC端左侧导航 -->
    <div v-if="!isMobile" class="sidebar-wrap">
      <LeftSide :in-drawer="true" />
    </div>
    <TopSide />
    <!-- 移动端左侧抽屉 -->
    <el-drawer v-model="mobileMenuDrawer" direction="ltr" size="240px" :with-header="false">
      <LeftSide />
    </el-drawer>

    <!-- ========== 主体内容 ========== -->
    <div class="main-content">
      <div class="order-page" :class="{ 'pc-offset': !isMobile }">
        <div class="page-top-title">
          <h1>我的订单</h1>
        </div>

        <!-- 筛选 -->
        <div class="order-filter">
          <el-tabs v-model="activeStatus" @tab-click="handleStatusChange">
            <el-tab-pane label="全部" name="1" />
            <el-tab-pane label="待付款" name="2" />
            <el-tab-pane label="已付款" name="3" />
          </el-tabs>
          <div class="filter-right">
            <el-radio-group v-model="activeLaiyuan" size="small" @change="loadOrders">
              <el-radio-button label="0">全部类型</el-radio-button>
              <el-radio-button label="1">积分充值</el-radio-button>
              <el-radio-button label="2">开通会员</el-radio-button>
            </el-radio-group>
          </div>
        </div>

        <!-- 订单表格 -->
        <div class="order-table-wrap">
          <el-table v-loading="loading" :data="pagedList" height="520" empty-text="暂无订单">
            <el-table-column label="订单号" prop="order_bianhao" min-width="200" />
            <el-table-column label="订单类型" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.order_laiyuan === 2 ? '开通会员' : '积分充值' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="金额" width="120">
              <template slot-scope="scope">
                <span class="money">¥{{ toFixed2(scope.row.order_money) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="110">
              <template slot-scope="scope">
                <span :class="Number(scope.row.pay_flag) === 1 ? 'status-paid' : 'status-unpaid'">
                  {{ Number(scope.row.pay_flag) === 1 ? '已支付' : '待付款' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="add_time" width="170" />
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button v-if="Number(scope.row.pay_flag) !== 1" type="text" @click="payAgain(scope.row)">继续支付</el-button>
                <span v-else class="op-done">已完成</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="table-pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="orderList.length"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- ========== 微信扫码支付弹窗 ========== -->
    <el-dialog title="微信扫码支付" :visible.sync="payDialogVisible" width="420px" :close-on-click-modal="false" @close="onPayDialogClose">
      <div class="pay-qrcode-wrap">
        <div v-if="payQrCodeUrl">
          <p class="pay-tip">
            请使用微信扫一扫，支付
            <span class="money">¥{{ toFixed2(payInfo.money) }}</span>
          </p>
          <div id="qrcode-box" style="display: inline-block"></div>
          <p class="pay-time-tip">二维码有效期5分钟，支付成功后积分自动到账</p>
        </div>
        <div v-else class="qr-loading">
          <i class="el-icon-loading"></i>
          <p>正在生成支付二维码...</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import LeftSide from '@/components/LeftSide.vue'
import TopSide from '@/components/TopSide.vue'

export default {
  components: { LeftSide, TopSide },
  data() {
    return {
      isMobile: false,
      mobileMenuDrawer: false,
      visible_loginMenu: false,

      loading: false,
      orderList: [], // 接口返回的全部订单
      pageNum: 1,
      pageSize: 10,

      activeStatus: '1', // 1 全部 2 待付款 3 已付款
      activeLaiyuan: '0', // 0 全部 1 积分充值 2 开通会员

      payDialogVisible: false,
      payQrCodeUrl: '',
      payInfo: { orderNo: '', money: 0 },
      payPollTimer: null
    }
  },
  computed: {
    pagedList() {
      const start = (this.pageNum - 1) * this.pageSize
      return this.orderList.slice(start, start + this.pageSize)
    }
  },
  watch: {
    payDialogVisible(val) {
      if (val) {
        this.drawQrCode()
      } else {
        const box = document.getElementById('qrcode-box')
        if (box) box.innerHTML = ''
      }
    },
    payQrCodeUrl() {
      this.drawQrCode()
    }
  },
  created() {
    const token = window.sessionStorage.getItem('token')
    this.visible_loginMenu = !!token
    if (!token) {
      this.$message.warning('请先登录')
      this.$router.push('/mob')
      return
    }
    this.loadOrders()
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
    if (this.payPollTimer) clearInterval(this.payPollTimer)
  },
  methods: {
    toFixed2(v) {
      return Number(v || 0).toFixed(2)
    },
    checkDevice() {
      this.isMobile = window.innerWidth <= 768
    },
    handleStatusChange() {
      this.pageNum = 1
      this.loadOrders()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
    },
    handleCurrentChange(val) {
      this.pageNum = val
    },
    handleAccountCommand(command) {
      switch (command) {
        case 'info':
          this.$router.push('/zichan')
          break
        case 'order':
          this.$router.push('/myorder')
          break
        case 'logout':
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('guest_mob')
          this.visible_loginMenu = false
          this.$message.success('退出登录成功')
          this.$router.push('/mob')
          break
      }
    },
    login() {
      this.$router.push('/mob')
    },

    // ================= 订单列表 =================
    async loadOrders() {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('get_api', {
          params: {
            C_type: 'my_order_list',
            order_status: this.activeStatus,
            order_laiyuan: this.activeLaiyuan
          }
        })
        const resData = JSON.parse(res.data)
        if (!resData || resData.length === 0) {
          this.orderList = []
          return
        }
        const payload = resData[0]
        if (payload.status !== 200) {
          this.orderList = []
          this.$message.error(payload.msg || '订单加载失败')
          return
        }
        this.orderList = payload.dataList || []
        this.pageNum = 1
      } catch (err) {
        console.error('订单接口请求失败', err)
        this.orderList = []
      } finally {
        this.loading = false
      }
    },

    // ================= 继续支付 =================
    async payAgain(row) {
      try {
        const { data } = await this.$http.post('/api/wxpay/repay', { orderNo: row.order_bianhao })
        if (data.code !== 200) {
          this.$message.error(data.msg || '发起支付失败')
          return
        }
        this.payInfo = { orderNo: data.data.orderNo, money: data.data.orderMoney || row.order_money }
        this.payQrCodeUrl = data.data.qrCodeUrl
        this.payDialogVisible = true
        this.startPollPayStatus()
      } catch (e) {
        console.error('继续支付失败', e)
        this.$message.error('发起支付失败')
      }
    },

    drawQrCode() {
      this.$nextTick(() => {
        const box = document.getElementById('qrcode-box')
        if (!box || !this.payQrCodeUrl) return
        box.innerHTML = ''
        // eslint-disable-next-line no-new
        new QRCode(box, { text: this.payQrCodeUrl, width: 220, height: 220 })
      })
    },

    startPollPayStatus() {
      if (this.payPollTimer) clearInterval(this.payPollTimer)
      this.payPollTimer = setInterval(async () => {
        if (!this.payInfo.orderNo) return
        try {
          const { data } = await this.$http.get('/api/wxpay/queryPay', {
            params: { orderNo: this.payInfo.orderNo }
          })
          if (data.code === 200 && data.data.status === 'success') {
            clearInterval(this.payPollTimer)
            this.payPollTimer = null
            this.$message.success('支付成功！积分已到账')
            this.payDialogVisible = false
            this.loadOrders()
          }
          if (data.code === 200 && (data.data.status === 'closed' || data.data.status === 'expire')) {
            clearInterval(this.payPollTimer)
            this.payPollTimer = null
            this.$message.info('订单已超时或关闭')
            this.payDialogVisible = false
            this.loadOrders()
          }
        } catch (err) {
          console.log('查询支付状态异常', err)
        }
      }, 2000)
    },

    onPayDialogClose() {
      if (this.payPollTimer) {
        clearInterval(this.payPollTimer)
        this.payPollTimer = null
      }
      this.payQrCodeUrl = ''
      this.loadOrders()
    }
  }
}
</script>

<style scoped>
.page-wrap {
  background-color: #fbfcfd;
  min-height: 100vh;
  padding-top: 56px;
  display: flex;
}

.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
  background: #fff;
}

.header-left {
  display: flex;
  align-items: center;
}

.hamburger-btn {
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  border: 1px solid #e8edf2;
  color: #666;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  border: 1px solid #e8edf2;
  transition: 0.2s;
}

.header-icon:hover {
  color: #22b8e6;
  border-color: #ccebfa;
}

.sidebar-wrap {
  width: 120px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 30px 20px;
  box-sizing: border-box;
}

.page-top-title {
  text-align: center;
  margin-bottom: 20px;
}
.page-top-title h1 {
  font-size: 24px;
  font-weight: normal;
  color: #333;
  margin: 0;
}

.order-filter {
  background: #fff;
  border: 1px solid #e8edf2;
  border-radius: 14px;
  padding: 8px 20px 16px;
  margin-bottom: 18px;
}

.filter-right {
  display: flex;
  justify-content: flex-end;
  margin-top: -6px;
}

.order-table-wrap {
  background: #fff;
  border: 1px solid #e8edf2;
  border-radius: 14px;
  padding: 16px 20px 8px;
}

.table-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
}

.money {
  color: #f53f3f;
  font-weight: bold;
}

.status-paid {
  color: #22b8e6;
}
.status-unpaid {
  color: #f56c6c;
}
.op-done {
  color: #999;
  font-size: 13px;
}

.pay-qrcode-wrap {
  text-align: center;
  padding: 10px 0;
}
.pay-tip {
  font-size: 15px;
  margin-bottom: 16px;
}
.pay-time-tip {
  margin-top: 12px;
  font-size: 13px;
  color: #999;
}
.qr-loading {
  padding: 40px 0;
  color: #666;
}
#qrcode-box {
  margin: 0 auto;
}
</style>
